<template>
  <el-dialog title="Adicionar Banner(Página Principal - 2)" :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" :modal-append-to-body="false" width="30%">
    <el-form size="small" label-position="top" hide-required-asterisk	:show-message="false">
      <el-form-item>
        <el-upload ref="upload" name="arquivo" :action="''" :auto-upload="false" multiple class="file-upload-box" accept="image/png,image/jpeg">
          <el-button type="primary" slot="trigger" style="width: 100%" icon="el-icon-search" round class="btn-box-shadow">Selecionar Arquivo</el-button>
          <div slot="tip">Arquivos jpg/png com tamanho de até 2MB</div>
        </el-upload>
      </el-form-item>
    </el-form>

    <span slot="footer">
      <el-button type="success" size="small" @click="uploadHandler()" style="margin-left: 10px;" round class="btn-box-shadow">Upload</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  props: {
    visibility: Boolean,
    tipo: String
  },

  data() {
    return {

    }
  },

  computed: {
    ...mapState("loginStore", {
      imobiliaria(state) {
        return state.usuarioLogado.imobiliaria;
      },
    }),
  },

  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("siteStore", ["uploadBannerImagemPrincipalView2"]),

    uploadHandler() {
      if(this.$refs.upload.uploadFiles.length >= 1) {
        this.uploadSite(this.$refs.upload.uploadFiles[0]);
      } else {
        this.$message.error("Selecione ao menos uma imagem");
      }
    },

    uploadSite(arquivo) {
      this.showLoading();
      if(this.indiceUpload >= this.quantidadeArquivos) {
        this.fechar();
        return;
      }

      let payload = new FormData();

      payload.append("arquivo", arquivo.raw);
      payload.append("path", arquivo.name);
      payload.append("imobiliaria", this.imobiliaria)

      this.uploadBannerImagemPrincipalView2(payload)
      .then(resultado => {
        switch (resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          case "FALHA":
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.$message.error("Erro ao comunicar-se com o servidor!");
      }).finally(() => {
        this.hideLoading();
      })
    },

    reset() {
      if(this.$refs.upload) { this.$refs.upload.clearFiles(); }
    },

    fechar() {
      this.reset();
      this.$emit("close");
      this.hideLoading();
    },
  }
}
</script>